import { useQuery } from '@tanstack/react-query';
import { requestActivityReport } from '../activityReport/activityReport';
import { DigestReportRequest } from '../activityReport/types/ActivityReport';

export function useActivityReport(data: DigestReportRequest) {
    return useQuery({
        queryKey: [`activityReport-${data.endDate}-${data.startDate}-${data.users.join('-')}`],
        queryFn: async ({ signal }) => (await requestActivityReport(data, signal))?.data,
    });
}
